module.exports = __webpack_public_path__ + "img/alreadySent.5da1492a.svg";